// Import React Library
import React, { Component } from "react"
import { connect } from "react-redux"
import { ACTIVE_MANUFACTURERS, GET_MANUFACTURERS_REQUEST } from "../../../actions/actionCreator"
import { NavLink } from "react-router-dom"
import { goToAnchor } from "react-scrollable-anchor"

class Manufacturers extends Component {

  componentDidMount () {
    this.props.dispatch(GET_MANUFACTURERS_REQUEST())
  }

  state = {
    currentActiveManufacturers: this.props.activeManufacturers,
    displayMenu: false,
  }

  render () {
    const { Manufacturers } = this.props
    if (!Manufacturers) return "Завантаження"

    const Item = Manufacturers.map((item) => {
      return <NavLink key={item._id} to={`/manufacturer/${item.translit}`} onClick={() => {
        this.props.dispatch(ACTIVE_MANUFACTURERS(item.translit))
        this.setState({
          displayMenu: false,
          currentActiveManufacturers: item.translit !== this.state.currentActiveManufacturers ? item.translit : null,
        })
        goToAnchor("beginProducts")
      }} exact={true} activeClassName="active">
        <li className={this.state.currentActiveManufacturers !== item.translit ? "item" : "item active"}>{item.name}</li>
      </NavLink>
    })

    return <div className="manufacturers">
          <div className="dropdown" onClick={() => {this.state.displayMenu ? this.setState({ displayMenu: false }) : this.setState({ displayMenu: true })}}>
            <div className="button">Виробники</div>
            {this.state.displayMenu ? <ul>{Item}</ul> : null}
          </div>
    </div>
  }
}

const mapStateToProps = ({ Manufacturers, activeManufacturers }) => {
  return {
    ManufacturersRequest: Manufacturers.request,
    Manufacturers: Manufacturers.data,
    ManufacturersError: Manufacturers.error,
    activeManufacturers: activeManufacturers,
  }
}

export default connect(mapStateToProps, null)(Manufacturers)
